import React from 'react';
import styles from './TicketBoardComponent.module.css';
import UserTicketCard from "../UserTicketCard/UserTicketCard";

const columns = ['Open', 'Acknowledged', 'InProgress', 'Awaiting', 'Resolved', 'Hold'];

const TicketBoardComponent = ({ data, setShowTicketUpdate, handleOpenTicketUpdate , viewNavigate}) => {
  const groupedData = columns.reduce((acc, col) => {
    acc[col] = (Array.isArray(data) ? data : []).filter(
        user => user.currentStage?.toLowerCase() === col.toLowerCase()
    );
    return acc;
}, {});

  return (
    <div className={styles.ticketBoard}>
      {columns.map((col) => (
        <div key={col} className={styles.column}>
          <div className={styles.columnHeader}>
            <h3>{col}</h3>
          </div>
          <div>
            {groupedData[col].length > 0 ? (
              groupedData[col].map((user) => (
                <UserTicketCard
                  user = {user}
                  handleOpenTicketUpdate={handleOpenTicketUpdate}
                  viewNavigate={viewNavigate}
                />
              ))
            ) : (
              <p className={styles.emptyText}>No Tickets</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketBoardComponent;
